import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  displayedColumns: string[] = ['model', 'fertcode', 'vertical', 'body_building_days', 'actions'];
  dataSource: any;
  selectedItem: any = {};
  isEditMode: boolean = false;
  pageSize: number;
  pageIndex: number;
  total_pages: number = 0;
  selectedFile: File;
  selectedFileName: string;
  filterValue: any;

  @ViewChild('formDialog', { static: false }) formDialog: TemplateRef<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('importDialog', { static: false }) importDialog: TemplateRef<any>;

  constructor(private dialog: MatDialog, private cdr: ChangeDetectorRef, private toastr: ToastrService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    if (localStorage.getItem('adminListPageSize') != null || localStorage.getItem('adminListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('adminListPageSize'));
      this.pageSize = (pagesize && !Number.isNaN(pagesize)) ? pagesize : 10;
    } else {
      this.pageSize = 10;
    }
    if (localStorage.getItem('adminListPage') != null || localStorage.getItem('adminListPage') != undefined) {
      let pagenumber = Number(localStorage.getItem('adminListPage'));
      this.pageIndex = (pagenumber && !Number.isNaN(pagenumber)) ? pagenumber + 1 : 1;
    } else {
      this.pageIndex = 1;
    }
    this.commonService.findMasters(this.selectedItem.id, this.pageIndex, this.pageSize, '').subscribe(data => {
      if (data['responseCode'] == 0) {
        this.dataSource = data.responseData.resultList;
        this.dataSource.paginator = this.paginator;
        this.total_pages = data.responseData.total_elements;
        localStorage.removeItem('adminListPage');
      } else {
        this.toastr.error(data['message'], "Error");
      }
    });
  }

  openAddForm() {
    this.isEditMode = false;
    this.selectedItem = {};
    this.dialog.open(this.formDialog);
  }

  edit(item) {
    this.isEditMode = true;
    this.selectedItem = { ...item };
    this.dialog.open(this.formDialog);
  }

  saveData() {
    if (this.isEditMode) {
      this.commonService.updateMaster(this.selectedItem, this.selectedItem.id).subscribe(data => {
        this.loadData();  // Reload data after successful edit
        this.toastr.success(data['message'], "Success");
      }, error => {          // Handle error
        this.toastr.error("Error Edit");
      });
    } else {
      this.commonService.createMaster(this.selectedItem).subscribe(data => {
        this.loadData();  // Reload data after successful creation
        this.toastr.success(data['message'], "Success");
      }, error => {          // Handle error
        this.toastr.error("Save Error");
      });
    }
    this.dialog.closeAll();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  exportData(): void {
    this.commonService.downloadMasters().subscribe((data: Blob) => {
      const blob = new Blob([data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'masters.csv'; // Adjust the filename as needed
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.toastr.success(data['message'], "Success");
    }, error => {        // Handle error
      this.toastr.error('Error downloading masters', error);
    });
  }

  openImportForm() {
    this.dialog.open(this.importDialog, {
      width: '500px',
      height: '200px',
      panelClass: 'custom-modal-style'
    });
  }

  handleFileInput(files: FileList): void {
    const file = files.item(0);
    if (file) {
      // Client-side validation for file type
      const allowedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv'];
      if (allowedTypes.includes(file.type)) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
      } else {
        // Reset the selected file and display an error message
        this.selectedFile = null;
        this.selectedFileName = null;
        this.toastr.error('Invalid file type. Please select an Excel or CSV file.');
      }
    } else {
      this.selectedFile = null;
      this.selectedFileName = null;
    }
  }

  uploadFile(): void {
    if (this.selectedFile) {
      this.commonService.createMasterByCsv(this.selectedFile).subscribe(data => {
        if (data['responseCode'] == 0) {
          this.loadData();  // Reload data after successful import
          this.closeDialog();
          this.toastr.success(data['message'], "Success");
        } else {
          this.toastr.error(data['message'], "Error");
        }
      }, error => {          // Handle error
        this.toastr.error('Error uploading file', error);
      });
    }
  }
  /**
   * Name: setPageData
   * purpose: To set pagesize for table
   */
  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('adminListPageSize', size);
    let index = event.pageIndex.toString();
    localStorage.setItem('adminListPage', index);
    if (this.filterValue) {
      this.searchfilter(this.filterValue);
    } else {
      this.loadData();
    }
  }
  /**
     * Name: searchfilter with API based pagination
     * purpose: To apply filter on call list data
     * @author: Vaibhav
     */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filterValue = filterValue;
    if (localStorage.getItem('adminListPageSize') != null || localStorage.getItem('adminListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('adminListPageSize'));
      this.pageSize = (pagesize && !Number.isNaN(pagesize)) ? pagesize : 10;
    } else {
      this.pageSize = 10;
    }
    if (localStorage.getItem('adminListPage') != null || localStorage.getItem('adminListPage') != undefined) {
      let pagenumber = Number(localStorage.getItem('adminListPage'));
      this.pageIndex = (pagenumber && !Number.isNaN(pagenumber)) ? pagenumber + 1 : 1;
    } else {
      this.pageIndex = 1;
    }
    this.commonService.findMasters(this.selectedItem.id, this.pageIndex, this.pageSize, filterValue).subscribe(data => {
      if (data['responseCode'] == 0) {
        this.dataSource = data.responseData.resultList;
        this.dataSource.paginator = this.paginator;
        this.total_pages = data.responseData.total_elements;
        localStorage.removeItem('adminListPage');
      } else {
        this.toastr.error(data['message'], "Error");
      }
    });
  }
}
